/**
 * Created by Mark on 22/11/2016.
 */



import React, { Component } from 'react';
import { NotFoundRoute , Router , Route , IndexRoute , hashHistory } from "react-router";
import ReactGA from 'react-ga';

import AuthenticationStore from './store/authentication-store.js';
import CurriculumStore from './store/curriculum-store.js';

import Environment from './constants/environment.js';
import Login from './screens/login.js';
import ForgottenPassword from './screens/forgotten-password.js'
import Curriculum from './screens/curriculum-selection.js';
import Songs from './screens/songs.js';
import Stories from './screens/stories.js';
import Scores from './screens/classes-scores-reports.js';
import Archive from './screens/classes-archive-reports.js';
import ClassesWizard from './screens/classes-wizard.js';
import HomeDashboard from './screens/dashboard.js';
import StaffCreation from './screens/staff-creation.js';
import StaffManagement from './screens/staff-management.js';
import ClassManagement from './screens/class-management.js';
import StudentManagement from './screens/student-management.js';
import AssignmentWizard from './screens/assignment-wizard.js'
import ClassProfile from './screens/classes-profile.js';
import assignmentOverview from './screens/assignment-management.js';
import StudentProfile from './screens/student-profile.js';
import ComingSoon from './screens/comming-soon.js';
import AssignmentOverview from './screens/assignment-overview.js';
import AssignmentEdit from './screens/assignment-edt.js';
import AssignmentDuplicate from './screens/assignment-duplicate.js';
import LessonPlansComponent from './screens/lesson-plans.js'
import SongsAndStoriesComponent from './screens/songs-stories.js'
import Printable from './screens/printable.js'
import DeletedStudentManagement from "./screens/deleted-student-management.js";
import ContentMap from "./screens/content-map-update.js";
import SubscriptionScreen from "./screens/subscription.js";
import Translation from './screens/translation.js'
import TeacherContent from './screens/content-bulider.js';
import TeacherContentOverview from './screens/content-bulider-overview.js';
import TeacherContentCheckout from './screens/content-bulider-checkout.js';
import TeacherContentCatalog  from './screens/content-bulider-catalog.js';
import TeacherContentMake from './screens/content-create.js';
import ContentAssign from './screens/content-assign.js';
import HomeworkOverview from './screens/new_screens/homework-overview.js';
import HomeworkBuilder  from './screens/new_screens/homework-builder.js';
ReactGA.initialize(Environment.GA_ID);

export default class ApplicationRouter  extends Component {

    constructor(){
        super();
        this.state = {isUserAuthenticated: AuthenticationStore.isAuthenticated()}
    }

    componentWillMount(){
        AuthenticationStore.on('CHANGE' , () => {
            this.setState({isUserAuthenticated: AuthenticationStore.isAuthenticated(),});
        });
    }

    logPageView() {
        ReactGA.set({ page: 'admin/'+window.location.hash });
        ReactGA.pageview('admin/'+window.location.hash);
    }

    requireAuth(nextState, replace) {
      

        if (!this.state.isUserAuthenticated) {
            replace({
                pathname: '/authenticate',
                state: { nextPathname: nextState.location.pathname }
            })
        }
    }

    render()
    {
        return (
            <Router onUpdate={this.logPageView} history={hashHistory}>
                <Route path="/"  component={Login} ></Route>
                <Route path="/authenticate"  component={Login}  ></Route>
                <Route path="/dashboard"  component={HomeDashboard} onEnter={this.requireAuth.bind(this)}></Route>
                <Route path="/forgotten-password"  component={ForgottenPassword} ></Route>
                <Route path="/classes/wizard"   component={ClassesWizard} onEnter={this.requireAuth.bind(this)}></Route>
                <Route path="/classes/wizard/edit/:classID"   component={ClassesWizard} onEnter={this.requireAuth.bind(this)}></Route>
                <Route path="/classes/scores"   component={Scores} onEnter={this.requireAuth.bind(this)}></Route>
                <Route path="/classes/scores/archive"   component={Archive} onEnter={this.requireAuth.bind(this)}></Route>
                <Route path="/staff/new"   component={StaffCreation} onEnter={this.requireAuth.bind(this)} ></Route>
                <Route path="/staff/management"   component={StaffManagement} onEnter={this.requireAuth.bind(this)} ></Route>
                <Route path="/class/management"   component={ClassManagement} onEnter={this.requireAuth.bind(this)}></Route>
                <Route path="/class/profile/:classID"   component={ClassProfile} onEnter={this.requireAuth.bind(this)}></Route>
                <Route path="/student/profile/:studentID"   component={StudentProfile} onEnter={this.requireAuth.bind(this)}></Route>
                <Route path="/class/profile/:classID/:panel"   component={ClassProfile} onEnter={this.requireAuth.bind(this)}></Route>
                <Route path="/student/management"   component={StudentManagement} onEnter={this.requireAuth.bind(this)}></Route>
                <Route path="/student/deleted"   component={DeletedStudentManagement} onEnter={this.requireAuth.bind(this)}></Route>

                <Route path="/assignment/managment"   component={assignmentOverview} onEnter={this.requireAuth.bind(this)}></Route>
                <Route path="/assignment/overview/:assignmentID"   component={AssignmentOverview} onEnter={this.requireAuth.bind(this)}></Route>
                <Route path="/assignment/duplicate/:assignmentID"   component={AssignmentDuplicate} onEnter={this.requireAuth.bind(this)}></Route>
                <Route path="/printables"   component={Printable} onEnter={this.requireAuth.bind(this)}></Route>
                <Route path="/translation"   component={Translation} onEnter={this.requireAuth.bind(this)}></Route>

                <Route path="/assignment/wizard"   component={AssignmentWizard} onEnter={this.requireAuth.bind(this)}></Route>
                <Route path="/assignment/edit/:assignmentID"   component={AssignmentEdit} onEnter={this.requireAuth.bind(this)}></Route>
                <Route path="/song/:unitID/:languagePrefix"   component={Songs} onEnter={this.requireAuth.bind(this)}></Route>
                <Route path="/story/:unitID/:languagePrefix"   component={Stories} onEnter={this.requireAuth.bind(this)}></Route>
                <Route path="/lessonplans"   component={LessonPlansComponent} onEnter={this.requireAuth.bind(this)}></Route>
                <Route path="/songs_and_stories"   component={SongsAndStoriesComponent} onEnter={this.requireAuth.bind(this)}></Route>
                <Route path="/content_map"   component={ContentMap} onEnter={this.requireAuth.bind(this)}></Route>
                <Route path="/subscription" component={SubscriptionScreen} onEnter={this.requireAuth.bind(this)}></Route>
                <Route path="/builder/overview"   component={TeacherContentOverview} onEnter={this.requireAuth.bind(this)}></Route>
                <Route path="/builder/assign/:catalogUID"   component={ContentAssign} onEnter={this.requireAuth.bind(this)}></Route>
                <Route path="/builder/checkout/:catalogUID"   component={TeacherContentCheckout} onEnter={this.requireAuth.bind(this)}></Route>
                <Route path="/builder/catalog/:myCalatlogUID/:catalogUID"   component={TeacherContentCatalog} onEnter={this.requireAuth.bind(this)}></Route>
                <Route path="/builder/catalog/:myCalatlogUID/:catalogUID/:learning/:support"   component={TeacherContentCatalog} onEnter={this.requireAuth.bind(this)}></Route>
                <Route path="/builder/maker"   component={TeacherContentMake} onEnter={this.requireAuth.bind(this)}></Route>
                <Route path="/homework/overview"   component={HomeworkOverview} onEnter={this.requireAuth.bind(this)}></Route>
                <Route path="/homework/builder"   component={HomeworkBuilder} onEnter={this.requireAuth.bind(this)}></Route>

                <Route path="*" component={ComingSoon} ></Route>
            </Router> )
    }
}




// WEBPACK FOOTER //
// ./src/application.router.js